import { render, staticRenderFns } from "./IntentUsages.vue?vue&type=template&id=7c019fc6&"
import script from "./IntentUsages.vue?vue&type=script&lang=js&"
export * from "./IntentUsages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports